import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './Select';

const SelectDevice = ({ value, devices = [], onChange, Icon }) => {
    // Find the selected device to display its label
    const selectedDevice = devices.find(device => device.deviceId === value);

    return (
        <Select value={value} onValueChange={onChange}>
            <SelectTrigger className="w-full bg-slate-700/50 border-slate-600 text-white">
                <div className="flex items-center gap-2 truncate">
                    {Icon && <Icon className="h-4 w-4 flex-shrink-0" />}
                    <SelectValue>
                        {selectedDevice ? selectedDevice.label : 'Select device...'}
                    </SelectValue>
                </div>
            </SelectTrigger>
            <SelectContent>
                {Array.isArray(devices) && devices.length > 0 ? (
                    devices.map((device) => (
                        <SelectItem
                            key={device.deviceId}
                            value={device.deviceId}
                            className="text-sm"
                        >
                            {device.label || `Default ${device.kind}`}
                        </SelectItem>
                    ))
                ) : (
                    <SelectItem value="no-devices" disabled className="text-sm text-gray-500">
                        No devices available
                    </SelectItem>
                )}
            </SelectContent>
        </Select>
    );
};

export default SelectDevice;